<div id="studio-nav-container">
  <div id="left-col">
    <div
      class="show-image-wrapper"
      [tooltip]="(studioShow$ | async)?.showName + ' - ' + (studioSession$ | async)?.sessionTitle">
      <img
        [src]="(studioShow$ | async)?.showImg"
        *ngIf="(studioShow$ | async)?.showImg && (studioSession$ | async)?.communityEvent !== true"
        alt="Show Image"
        class="show-image" />
      <img
        [src]="'assets/images/SC_OfficeHours_Square.png'"
        *ngIf="
          (studioSession$ | async)?.communityEvent === true &&
          (studioSession$ | async)?.sessionTitle.includes('Office Hours')
        "
        alt="Show Image"
        class="show-image" />
      <img
        [src]="'assets/images/Gradient-Logo-80x80.png'"
        *ngIf="
          (studioSession$ | async)?.communityEvent === true &&
          !(studioSession$ | async)?.sessionTitle.includes('Office Hours')
        "
        alt="Show Image"
        class="show-image" />
    </div>

    <div
      class="session-title"
      [class.minimized]="(localParticipantDolby$ | async)?.minimized || (localParticipantDaily$ | async)?.minimized">
      <h1 class="body-bold">
        {{ (studioShow$ | async)?.showName }}
      </h1>
      <h2 class="body-regular">
        {{ (studioSession$ | async)?.sessionTitle }}
      </h2>
    </div>

    <ion-button
      *ngIf="(localParticipantDaily$ | async)?.minimized || (localParticipantDaily$ | async)?.minimized"
      (click)="viewSelf()"
      tooltip="View Yourself"
      fill="clear"
      size="small"
      class="view-self-button">
      <ion-icon src="/assets/icons/24px/view-self.svg"> </ion-icon>
      <ion-label> Show Self </ion-label>
    </ion-button>
  </div>

  <div *ngIf="recording" id="center-col">
    <div class="recording-indicator">
      <ion-icon *ngIf="!warnings" src="/assets/icons/32px/record-outline-bold.svg" class="recording-icon"></ion-icon>
      <ion-icon
        *ngIf="warnings"
        src="/assets/icons/32px/record-outline-bold.svg"
        class="warning-icon"
        [tooltip]="warnings"></ion-icon>
      <span class="session-timer long-text">Recording - </span>
      <span class="session-timer body-bold">{{ timer }} </span>
    </div>
  </div>

  <div *ngIf="!recording" id="center-col">
    <object class="navlogo-sm" tabindex="-1" data="/assets/images/SC_LogoMark-Circle_Animated.svg"></object>
    <ion-img
      class="navlogo"
      [src]="
        (theme$ | async) === 'dark-theme'
          ? 'assets/images/SC_D_Logo_Horizontal-LM.svg'
          : '/assets/images/SC_D_Logo_Horizontal-DM.svg'
      "></ion-img>
  </div>

  <div id="right-col">
    <!-- <ion-button
      *ngIf="iPhoneiPadDevice"
      (click)="learnMoreiPhoneiPadBeta()"
      aria-label="iOS Beta active, learn more"
      tooltip="Learn More"
      class="ios-beta"
      color="dark"
      slot="start">
      <p>iOS BETA</p>
    </ion-button> -->

    <!-- <ion-button
      *ngIf="(studioPilotProgram$ | async)?.toggle && (role$ | async) >= roleLimits.PARTICIPANT_READ"
      aria-label="Pilot Program Feedback"
      (click)="openBetaFeedback()"
      tooltip="Pilot Program is Enabled"
      color="dark"
      class="pilot-feedback">
      <p>PILOT</p>
    </ion-button> -->

    <ion-button
      *ngIf="(autoplayBlocked$ | async) === true"
      fill="solid"
      class="unmute-button"
      (click)="playBlockedAudio()"
      tooltip="Unmute Conversation"
      aria-label="Unmute Conversation">
      <ion-icon class="bounce" slot="icon-only" color="secondary" src="/assets/icons/24px/sound-off.svg"> </ion-icon>
    </ion-button>

    <sc-help-button></sc-help-button>

    <ion-button
      class="session-participants"
      fill="clear"
      size="small"
      aria-label="Session Participants"
      [tooltip]="participantsTooltip"
      (click)="toggleSidebar('participants')">
      <ion-icon src="/assets/icons/24px/member.svg"></ion-icon>
      <span class="participant-count">{{ stageCount }} {{ backstageCount ? ' | ' + backstageCount : '' }}</span>
    </ion-button>

    <ion-button
      aria-label="Leave Session"
      tooltip="Leave Session"
      class="leave-session-button"
      (click)="leaveSession($event)"
      [disabled]="recording">
      <span class="bold">Leave<span class="long-text">&nbsp;Session</span></span>
    </ion-button>

    <ion-button
      aria-label="Leave Session"
      tooltip="Leave Session"
      class="leave-session-button-sm"
      (click)="leaveSession($event)"
      [disabled]="recording">
      <ion-icon slot="icon-only" color="error" src="/assets/icons/24px/leave.svg"> </ion-icon>
    </ion-button>
  </div>
</div>
